import React from 'react';

import * as ViewHooks from '../../../../state/views/hooks';
import {panelViews} from '../../../PanelBank/types';
import {PanelSettingsHeader} from '../components/PanelSettingsHeader';
import {SectionSettingsContextProvider} from '../SectionSettingsContextProvider';
import {MediaPanelSettingsContextProvider} from './contexts/MediaPanelSettingsContextProvider';
import {MediaSettingsDrawerContent} from './MediaSettingsDrawerContent';
import {type MediaSettingsDrawerPanelProps, SettingsLevel} from './types';

export const MediaSettingsDrawer = ({
  panelRef,
  panelBankSectionConfigRef,
}: MediaSettingsDrawerPanelProps) => {
  const panel = ViewHooks.usePart(panelRef);
  if (panel.viewType !== panelViews.mediaBrowser) {
    return null;
  }
  return (
    <SectionSettingsContextProvider sectionRef={panelBankSectionConfigRef}>
      <MediaPanelSettingsContextProvider
        panelRef={panelRef}
        panelBankSectionConfigRef={panelBankSectionConfigRef}>
        <MediaSettingsDrawerContent
          header={<PanelSettingsHeader />}
          description="Customize settings for media in this panel."
          settingsLevel={SettingsLevel.PANEL}
        />
      </MediaPanelSettingsContextProvider>
    </SectionSettingsContextProvider>
  );
};
